import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import styled, { keyframes } from 'styled-components';

var _templateObject, _templateObject2;
var loading = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  20% {\n    opacity: 0.2;\n  }\n  40% {\n    opacity: 0.4;\n  }\n  60% {\n    opacity: 0.6;\n  }\n  80% {\n    opacity: 0.8;\n  }\n  100% {\n    opacity: 1;\n  }\n"])));
var LoadingComponentContainer = styled.main(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: center;\n  background-color: ", ";\n  z-index: 8888;\n  text-align: center;\n\n  left: 0;\n  top: 0;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n\n  .loadingText {\n    font-family: \"PlayfairDisplay\";\n    font-size: 40px;\n    font-weight: bold;\n    color: #00234b;\n    ", ";\n  }\n\n  .loadingAnimation {\n    margin-top: 40px;\n    ", ";\n  }\n\n  .loadingAnimation > div {\n    width: 50px;\n    height: 6px;\n    background: #b5985b;\n    display: inline-block;\n    animation: ", " 1.1s infinite ease-in-out both;\n    margin-right: 6px;\n    ", ";\n  }\n\n  .loadingAnimation .loadingAnimation__item1 {\n    animation-delay: -0.8s;\n  }\n\n  .loadingAnimation .loadingAnimation__item2 {\n    animation-delay: -0.6s;\n  }\n\n  .loadingAnimation .loadingAnimation__item3 {\n    animation-delay: -0.4s;\n  }\n\n  .loadingAnimation .loadingAnimation__item4 {\n    animation-delay: -0.2s;\n  }\n\n  .loadingAnimation .loadingAnimation__item5 {\n    animation-delay: -0s;\n  }\n"])), function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.small && "font-size: 28px;";
}, function (props) {
  return props.small && "margin-top: 28px;";
}, loading, function (props) {
  return props.small && "width: 40px; height: 4px; margin-right: 4px;";
});
LoadingComponentContainer.displayName = "LoadingComponentContainer";
var LoadingComponentDef = function LoadingComponentDef(props) {
  return /*#__PURE__*/React__default.createElement(LoadingComponentContainer, props, /*#__PURE__*/React__default.createElement("div", {
    className: "loadingText"
  }, props.text), /*#__PURE__*/React__default.createElement("div", {
    className: "loadingAnimation"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "loadingAnimation__item1"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "loadingAnimation__item2"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "loadingAnimation__item3"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "loadingAnimation__item4"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "loadingAnimation__item5"
  })));
};
LoadingComponentDef.defaultProps = {
  text: "Loading...",
  backgroundColor: "#e2e2e2"
};
LoadingComponentDef.propTypes = {
  text: PropTypes.string,
  // Display specific text
  backgroundColor: PropTypes.string,
  // Background color "rgba(255, 255, 255, 0.0)"
  small: PropTypes.bool // Display small size of LoadingCompoent
};
var withLoadingComponent = function withLoadingComponent(Comp) {
  return function (props) {
    return props.loading ? /*#__PURE__*/React__default.createElement(LoadingComponentDef, null) : /*#__PURE__*/React__default.createElement(Comp, props);
  };
};
var LoadingComponent = LoadingComponentDef;

export { LoadingComponent, LoadingComponentContainer, withLoadingComponent };
